import { __generator } from "tslib";
import { call, select, delay } from 'redux-saga/effects';
import get from 'lodash/get';
import { getGallectionById } from '../selectors';
import { request } from '../../xhr';
import { getGallectionType } from '../helpers';
function setGallectionDescription(action) {
    var _a, folderId, pointsPrice, gallection, params;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, delay(500)];
            case 1:
                _d.sent(); // + takeLatest = debounced
                _a = action.payload, folderId = _a.folderId, pointsPrice = _a.pointsPrice;
                return [4 /*yield*/, select(getGallectionById, folderId)];
            case 2:
                gallection = _d.sent();
                if (!gallection) {
                    return [2 /*return*/];
                }
                params = {
                    type: (_b = getGallectionType(gallection)) !== null && _b !== void 0 ? _b : 'collection',
                    folderid: gallection.folderId,
                    name: gallection.name,
                    description: (_c = gallection.description) !== null && _c !== void 0 ? _c : undefined,
                    cover_deviationid: gallection.type === 'stash'
                        ? undefined
                        : get(gallection, 'thumb.deviationId'),
                    points_price: pointsPrice,
                };
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: 'gallection/folders/update',
                        data: params,
                    })];
            case 3:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
export default setGallectionDescription;
//# sourceMappingURL=saveChangedGallectionPrice.js.map